import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SmallBackButton } from "../../../../core/components/CustomButton";
import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";
import CircularProgress from "../../../../core/components/CircularProgress";
import { RootState } from "../../../../core/store/store";
import { VideoPlay } from "../../../../core/icons/VideoPlay";

export const TutorialScreen = () => {
	const navigate = useNavigate();
	const { idVideos, isLoading } = useSelector((state: RootState) => state.admin);

	return (
		<Column className="bg-white p-6 md:p-8 gap-4 md:gap-5 max-md:overflow-y-auto">
			<SmallBackButton onClick={() => navigate("/settings")} className="mb-2" />
			<TextComponent variant="h2" className="font-bold">
				Tutorial
			</TextComponent>
			{isLoading ? (
				<div className="py-12">
					<CircularProgress />
				</div>
			) : (
				<Column className="gap-4">
					{idVideos.map((video) => (
						<div key={video.id} className="overflow-hidden rounded-xl bg-black">
							<button
								type="button"
								className="relative block w-full"
								onClick={() => navigate(`/settings/tutorial/${video.id}`)}
							>
								<img
									src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
									alt={`Tutorial video ${video.id}`}
									className="h-[260px] w-full object-cover"
								/>
								<div className="absolute inset-0 flex items-center justify-center bg-black/30">
									<VideoPlay />
								</div>
							</button>
						</div>
					))}
				</Column>
			)}
		</Column>
	);
};
